var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-menu-options is-props-col use-bscroll",staticStyle:{"background":"white"}},[_c('div',{staticStyle:{"margin":"10px"}},[_c(this.currentTabComponent,{tag:"component",attrs:{"bezieAppObj":this.bezieAppObj}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }